// © Microsoft Corporation. All rights reserved.

/**
 * Defines valid milestone event types
 */
export enum ExperienceMilestoneEventTypes {
    /**
   * Fired when all the initial DOM elements for the experience have been added (i.e. onComponentDidMount)
   * The DOM may not be completely rendered by the browser when then milestone is reached
   */
    domComplete,

    /**
   * Fired if the experience hits an unrecoverable error
   */
    error,

    /**
   * Fired when the experience is initialized
   */
    initialized,

    /**
   * Fired when the experience is initially rendered. This is after the browser has processed all of the DOM elements that were
   * added in the experience render function.
   */
    rendered,

    /**
   * Fired when the experience's stale state revalidation completes.
   */
    staleRevalidationComplete,

    /**
   * Fired when the experience is visually ready, which is a business metric and defined in the MSNews Performance Metrics documentation.
   */
    visuallyReady,

    /**
   * Fired when the experience starts loading
   */
    startLoading
}
